/**
 * Datum pro API ve tvaru `YYYY-MM-DD` v místním čase.
 *
 * `toISOString()` se schválně nepoužívá: převádí na UTC, takže sken v 01:00
 * ve skladu by se ptal na trasy z předešlého dne. Ve dvě ráno u pásu to nikdo
 * neodhalí.
 */
export function toIsoDate(date: Date): string {
  const m = `${date.getMonth() + 1}`.padStart(2, '0');
  const d = `${date.getDate()}`.padStart(2, '0');
  return `${date.getFullYear()}-${m}-${d}`;
}

export function todayIso(): string {
  return toIsoDate(new Date());
}
